// Centralized tier limits - matches backend model/subscription_tiers.go
export const TIER_LIMITS = {
  starter: {
    maxTracks: 3,
    maxCollaborators: 0,
  },
  artist: {
    maxTracks: 100,
    maxCollaborators: 10,
  },
  studio: {
    maxTracks: -1, // -1 = unlimited
    maxCollaborators: -1, // -1 = unlimited
  },
} as const;

// Helper functions
export const getTierLimits = (tier: string) => {
  return TIER_LIMITS[tier as keyof typeof TIER_LIMITS] || TIER_LIMITS.starter;
};

export const formatTrackLimit = (tier: string) => {
  const limits = getTierLimits(tier);
  if (limits.maxTracks === -1) return 'Unlimited tracks';
  return `${limits.maxTracks} tracks`;
};

export const formatCollaboratorLimit = (tier: string) => {
  const limits = getTierLimits(tier);
  if (limits.maxCollaborators === -1) return 'Unlimited collaborators per track';
  if (limits.maxCollaborators === 0) return '0 collaborators';
  return `${limits.maxCollaborators} collaborators per track`;
};

export const formatTierDescription = (tier: string) => {
  const limits = getTierLimits(tier);
  const trackText = limits.maxTracks === -1 ? 'Unlimited tracks' : `${limits.maxTracks} tracks`;
  const collaboratorText = limits.maxCollaborators === -1 
    ? 'unlimited collaborators per track' 
    : limits.maxCollaborators === 0 
    ? '0 collaborators per track'
    : `${limits.maxCollaborators} collaborators per track`;
  
  return `${trackText}, ${collaboratorText}`;
};
